import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { AviationEvent } from '../../shared/models/aviation-event.model';

@Component({
  selector: 'app-edit-event-description',
  templateUrl: './edit-event-description.component.html',
  styleUrls: ['./edit-event-description.component.scss']
})
export class EditEventDescriptionComponent implements OnInit {
  formGroup: FormGroup;
  aviationEvent: AviationEvent;
  charRemainingCnt: number;
  _originDesc: string;
  _MAX_CHARACTERS = 5000;
  isBusy = false;

  constructor(private _matDialogRef: MatDialogRef<EditEventDescriptionComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _aviationEventsService: AviationEventsService) {
    this.aviationEvent = data.aviationEvent;
    this.charRemainingCnt = this.aviationEvent.description ?
      this._MAX_CHARACTERS - this.aviationEvent.description.length : this._MAX_CHARACTERS;
    this._originDesc = this.aviationEvent.description;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });

    this.formGroup = new FormGroup({
      description: new FormControl('', [Validators.required, Validators.maxLength(this._MAX_CHARACTERS)])
    });
  }

  cancel () {
    this.aviationEvent.description = this._originDesc;
    this._matDialogRef.close(null);
  }

  textAreaChanged () {
    this.charRemainingCnt = this.aviationEvent.description.length <= this._MAX_CHARACTERS ?
      this._MAX_CHARACTERS - this.aviationEvent.description.length : 0;
  }

  async save () {
    if (this.aviationEvent.description) {
      this.aviationEvent.description = this.aviationEvent.description.trim();
    }
    try {
      this.isBusy = true;
      await this._aviationEventsService.updateAviationEvent(this.aviationEvent);
      this.isBusy = false;
      this._matDialogRef.close(true);
    } catch (e) {
      this.isBusy = false;
      this._matDialogRef.close(false);
    }
  }
}
